(function () {
  var STORAGE_KEY = 'xtrait_wishlist_v1';

  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (err) {
      return [];
    }
  }

  function write(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function normalizeButton(button) {
    return {
      id: button.getAttribute('data-product-id') || button.getAttribute('data-product-handle'),
      handle: button.getAttribute('data-product-handle') || '',
      title: button.getAttribute('data-product-title') || '',
      vendor: button.getAttribute('data-product-vendor') || '',
      url: button.getAttribute('data-product-url') || '',
      image: button.getAttribute('data-product-image') || '',
      price: button.getAttribute('data-product-price') || ''
    };
  }

  function isSaved(items, id) {
    return items.some(function (item) { return String(item.id) === String(id); });
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  var entryProductCache = {};
  var priceNormalizeTimer = null;
  var priceObserverStarted = false;
  var searchPriceTimer = null;
  var searchPriceObserverStarted = false;

  function installFeaturedEdgeFix() {
    if (document.getElementById('x-featured-edge-fix')) return;
    var style = document.createElement('style');
    style.id = 'x-featured-edge-fix';
    style.textContent = [
      'body.is-home .x-featured__row{justify-content:flex-start!important;scroll-padding-inline:var(--gutter,32px)!important;}',
      'body.is-home .x-featured__row .x-featured__card:first-child{margin-left:0!important;}'
    ].join('');
    (document.head || document.documentElement).appendChild(style);
  }

  function formatMoney(cents) {
    var amount = (parseInt(cents || 0, 10) / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return '$' + amount;
  }

  function variantPrice(variant) {
    return parseInt(variant && variant.price ? variant.price : 0, 10) || 0;
  }

  function isSampleVariant(variant) {
    var title = String((variant && (variant.public_title || variant.title || variant.name)) || '').toLowerCase();
    var compact = title.replace(/\s+/g, '').replace(/-/g, '');
    return title.indexOf('sample') !== -1 ||
      title.indexOf('discovery') !== -1 ||
      title.indexOf('vial') !== -1 ||
      title.indexOf('decant') !== -1 ||
      title.indexOf('travel') !== -1 ||
      title.indexOf('tester') !== -1 ||
      title.indexOf('mini') !== -1 ||
      compact.indexOf('0.7ml') !== -1 ||
      compact.indexOf('1ml') !== -1 ||
      compact.indexOf('1.5ml') !== -1 ||
      compact.indexOf('2ml') !== -1 ||
      compact.indexOf('3ml') !== -1 ||
      compact.indexOf('5ml') !== -1 ||
      compact.indexOf('10ml') !== -1 ||
      compact.indexOf('15ml') !== -1;
  }

  function highestVariant(variants) {
    return (variants || []).reduce(function (best, variant) {
      if (!variantPrice(variant)) return best;
      if (!best) return variant;
      return variantPrice(variant) > variantPrice(best) ? variant : best;
    }, null);
  }

  function displayVariantFromProduct(product) {
    if (!product || !Array.isArray(product.variants) || !product.variants.length) return null;
    var availableBottles = product.variants.filter(function (variant) {
      return variant.available && !isSampleVariant(variant);
    });
    if (availableBottles.length) return highestVariant(availableBottles);
    var bottles = product.variants.filter(function (variant) { return !isSampleVariant(variant); });
    if (bottles.length) return highestVariant(bottles);
    var available = product.variants.filter(function (variant) { return variant.available; });
    return highestVariant(available.length ? available : product.variants);
  }

  function productJsonUrl(card) {
    if (!card) return '';
    var viewLink = card.querySelector('.product-card__view');
    var raw = card.getAttribute('data-product-url') ||
      (viewLink ? viewLink.getAttribute('href') : '') ||
      (card.getAttribute('data-product-handle') ? '/products/' + card.getAttribute('data-product-handle') : '');
    if (!raw) return '';
    try {
      var url = new URL(raw, window.location.origin);
      return url.origin + url.pathname.replace(/\/$/, '') + '.js';
    } catch (err) {
      return raw.split('?')[0].replace(/\/$/, '') + '.js';
    }
  }

  function applyDisplayVariantToCard(card, variant) {
    if (!card || !variant) return;
    var price = variantPrice(variant);
    if (!price) return;
    var variantId = variant.id ? String(variant.id) : '';
    var variantTitle = variant.public_title || variant.title || variant.name || '';
    var available = variant.available !== false;

    card.setAttribute('data-x-price', String(price / 100));
    card.setAttribute('data-x-price-source', 'bottle');
    card.setAttribute('data-x-display-variant-title', variantTitle);
    card.setAttribute('data-x-entry-price-normalized', '1');
    card.setAttribute('data-x-available', available ? 'true' : 'false');
    if (variantId) {
      card.setAttribute('data-variant-id', variantId);
      card.setAttribute('data-product-variant-id', variantId);
    }

    var priceRow = card.querySelector('.price-row');
    if (priceRow) {
      var from = priceRow.querySelector('.from');
      if (from) from.remove();

      var priceEl = priceRow.querySelector('.price');
      if (!priceEl) {
        priceEl = document.createElement('span');
        priceRow.appendChild(priceEl);
      }
      priceEl.className = 'price';
      priceEl.textContent = formatMoney(price);
    }

    if (variantId) {
      card.querySelectorAll('[data-variant-id], [data-product-variant-id]').forEach(function (node) {
        node.setAttribute('data-variant-id', variantId);
        node.setAttribute('data-product-variant-id', variantId);
      });
      card.querySelectorAll('input[name="id"]').forEach(function (input) {
        input.value = variantId;
      });
    }

    card.querySelectorAll('[data-product-price]').forEach(function (node) {
      node.setAttribute('data-product-price', formatMoney(price));
    });

    var hint = card.querySelector('.product-card__qv-hint');
    if (hint) hint.textContent = available ? 'Quick view' : 'Sold out';
  }

  function hydrateCardEntryPrice(card) {
    if (!card || card.getAttribute('data-x-price-source') === 'bottle' || card.getAttribute('data-x-entry-price-state') === 'loading') return;
    var jsonUrl = productJsonUrl(card);
    if (!jsonUrl) return;
    card.setAttribute('data-x-entry-price-state', 'loading');

    if (!entryProductCache[jsonUrl]) {
      entryProductCache[jsonUrl] = fetch(jsonUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .catch(function () { return null; });
    }

    entryProductCache[jsonUrl].then(function (product) {
      var variant = displayVariantFromProduct(product);
      if (variant) {
        applyDisplayVariantToCard(card, variant);
        card.setAttribute('data-x-entry-price-state', 'done');
      } else {
        card.setAttribute('data-x-entry-price-state', 'missing');
      }
      sync();
    }).catch(function () {
      card.setAttribute('data-x-entry-price-state', 'error');
    });
  }

  function normalizeProductCardPrices(scope, maxCards) {
    Array.prototype.slice.call((scope || document).querySelectorAll('.product-card'))
      .filter(function (card) { return card.getAttribute('data-x-price-source') !== 'bottle'; })
      .slice(0, maxCards || 80)
      .forEach(hydrateCardEntryPrice);
  }

  function schedulePriceNormalize(scope) {
    if (priceNormalizeTimer) window.clearTimeout(priceNormalizeTimer);
    priceNormalizeTimer = window.setTimeout(function () {
      normalizeProductCardPrices(scope || document, 80);
    }, 120);
  }

  function productJsonUrlFromSearchRow(row) {
    if (!row) return '';
    var raw = row.getAttribute('href') || '';
    if (!raw) return '';
    try {
      var url = new URL(raw, window.location.origin);
      var match = url.pathname.match(/\/products\/([^/]+)/);
      if (!match) return '';
      return url.origin + '/products/' + match[1] + '.js';
    } catch (err) {
      var clean = raw.split('?')[0].replace(/\/$/, '');
      var fallbackMatch = clean.match(/\/products\/([^/]+)/);
      return fallbackMatch ? '/products/' + fallbackMatch[1] + '.js' : '';
    }
  }

  function hydrateSearchPriceRow(row) {
    if (!row || row.getAttribute('data-x-search-bottle-price-state') === 'loading') return;
    var priceNode = row.querySelector('.x-search__price');
    if (!priceNode) return;

    var jsonUrl = productJsonUrlFromSearchRow(row);
    if (!jsonUrl) return;

    row.setAttribute('data-x-search-bottle-price-state', 'loading');
    if (!entryProductCache[jsonUrl]) {
      entryProductCache[jsonUrl] = fetch(jsonUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .catch(function () { return null; });
    }

    entryProductCache[jsonUrl].then(function (product) {
      var variant = displayVariantFromProduct(product);
      var price = variantPrice(variant);
      if (price) {
        priceNode.textContent = formatMoney(price);
        priceNode.removeAttribute('aria-busy');
        row.setAttribute('data-x-search-bottle-price-state', 'done');
      } else {
        row.setAttribute('data-x-search-bottle-price-state', 'missing');
      }
    }).catch(function () {
      row.setAttribute('data-x-search-bottle-price-state', 'error');
    });
  }

  function normalizeSearchPrices(scope) {
    Array.prototype.slice.call((scope || document).querySelectorAll('.x-search__list a'))
      .forEach(hydrateSearchPriceRow);
  }

  function scheduleSearchPriceNormalize(scope) {
    if (searchPriceTimer) window.clearTimeout(searchPriceTimer);
    searchPriceTimer = window.setTimeout(function () {
      normalizeSearchPrices(scope || document);
    }, 80);
  }

  function initSearchPriceObserver() {
    if (searchPriceObserverStarted || !document.body || !window.MutationObserver) return;
    searchPriceObserverStarted = true;
    new MutationObserver(function (mutations) {
      var hasSearchRows = mutations.some(function (mutation) {
        return Array.prototype.slice.call(mutation.addedNodes || []).some(function (node) {
          return node.nodeType === 1 && (
            (node.matches && (node.matches('.x-search__list a') || node.matches('[data-x-search-results]'))) ||
            (node.querySelector && node.querySelector('.x-search__list a'))
          );
        });
      });
      if (hasSearchRows) scheduleSearchPriceNormalize(document);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function initPriceObserver() {
    if (priceObserverStarted || !document.body || !window.MutationObserver) return;
    priceObserverStarted = true;
    new MutationObserver(function (mutations) {
      var hasProductCards = mutations.some(function (mutation) {
        return Array.prototype.slice.call(mutation.addedNodes || []).some(function (node) {
          return node.nodeType === 1 && (
            (node.matches && node.matches('.product-card')) ||
            (node.querySelector && node.querySelector('.product-card'))
          );
        });
      });
      if (hasProductCards) schedulePriceNormalize(document);
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.XtraitNormalizeProductPrices = normalizeProductCardPrices;

  function syncButtons(items) {
    document.querySelectorAll('[data-x-wishlist-toggle]').forEach(function (button) {
      var id = button.getAttribute('data-product-id') || button.getAttribute('data-product-handle');
      var active = isSaved(items, id);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      var title = button.getAttribute('data-product-title') || 'this fragrance';
      button.setAttribute('aria-label', (active ? 'Remove ' : 'Save ') + title + (active ? ' from wishlist' : ' to wishlist'));
    });
  }

  function syncCounts(items) {
    document.querySelectorAll('[data-x-wishlist-count]').forEach(function (count) {
      count.textContent = items.length;
      count.hidden = items.length === 0;
    });
  }

  function renderDrawer(items) {
    var list = document.querySelector('[data-x-wishlist-list]');
    if (!list) return;

    if (!items.length) {
      list.innerHTML =
        '<div class="x-wishlist__empty">' +
          '<p>No saved bottles yet.</p>' +
          '<a href="/collections/all">Shop fragrance</a>' +
        '</div>';
      return;
    }

    list.innerHTML = items.map(function (item) {
      return (
        '<article class="x-wishlist__item" data-x-wishlist-item="' + escapeHtml(item.id) + '">' +
          '<a class="x-wishlist__media" href="' + escapeHtml(item.url) + '">' +
            (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="">' : '') +
          '</a>' +
          '<div>' +
            '<div class="x-wishlist__vendor">' + escapeHtml(item.vendor) + '</div>' +
            '<a class="x-wishlist__name" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>' +
            '<div class="x-wishlist__price">' + escapeHtml(item.price) + '</div>' +
          '</div>' +
          '<button type="button" class="x-wishlist__remove" data-x-wishlist-remove="' + escapeHtml(item.id) + '">Remove</button>' +
        '</article>'
      );
    }).join('');
  }

  function sync() {
    var items = read();
    syncButtons(items);
    syncCounts(items);
    renderDrawer(items);
  }

  function initFeaturedFallback(scope) {
    (scope || document).querySelectorAll('[data-x-featured]').forEach(function (section) {
      if (section.dataset.xFeaturedFallbackInit === '1') return;
      section.dataset.xFeaturedFallbackInit = '1';
      var row = section.querySelector('[data-x-featured-row]');
      var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-x-featured-mode]'));
      if (!row || !buttons.length) return;

      var limit = parseInt(section.getAttribute('data-products-count') || '8', 10);
      var kicker = section.querySelector('[data-x-featured-kicker]');
      var titleMain = section.querySelector('[data-x-featured-title-main]');
      var titleItalic = section.querySelector('[data-x-featured-title-italic]');
      var lede = section.querySelector('[data-x-featured-lede]');
      var link = section.querySelector('[data-x-featured-link]');
      var modesEl = section.querySelector('[data-x-featured-modes]');
      var edgePrev = section.querySelector('[data-x-featured-edge-prev]');
      var edgeNext = section.querySelector('[data-x-featured-edge-next]');
      var edgeFrame = null;
      var edgeVelocity = 0;
      var edgeLastTime = 0;
      var edgeSyncFrame = null;
      var edgeMedia = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 961px)') : null;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var loadId = 0;
      var modes = [
        {
          key: 'current',
          html: row.innerHTML,
          loaded: true,
          kicker: kicker ? kicker.textContent.trim() : '',
          titleMain: titleMain ? titleMain.textContent.trim() : 'The current',
          titleItalic: titleItalic ? titleItalic.textContent.trim() : 'edit.',
          lede: lede ? lede.textContent.trim() : '',
          linkText: link ? link.textContent.trim() : 'Shop all fragrance →',
          linkHref: link ? link.getAttribute('href') : '/collections/all'
        },
        {
          key: 'best',
          url: section.getAttribute('data-best-url') || '/collections/all?sort_by=best-selling',
          kicker: 'Best sellers',
          titleMain: 'Best',
          titleItalic: 'sellers.',
          lede: 'The bottles shoppers keep coming back for right now.',
          linkText: 'Shop best sellers →',
          linkHref: section.getAttribute('data-best-url') || '/collections/all?sort_by=best-selling'
        },
        {
          key: 'newest',
          url: section.getAttribute('data-newest-url') || '/collections/all?sort_by=created-descending',
          kicker: 'Newest additions',
          titleMain: 'Newest',
          titleItalic: 'additions.',
          lede: 'Fresh arrivals just added to the shelf.',
          linkText: 'Shop new arrivals →',
          linkHref: section.getAttribute('data-newest-url') || '/collections/all?sort_by=created-descending'
        }
      ];

      function cardIdentity(card) {
        return card.getAttribute('data-product-id') ||
          card.getAttribute('data-product-handle') ||
          (card.querySelector('.product-card__view') && card.querySelector('.product-card__view').getAttribute('href')) ||
          card.textContent.trim();
      }

      function seenCardsFrom(scope) {
        var seen = {};
        Array.prototype.slice.call(scope.querySelectorAll('.product-card')).forEach(function (card) {
          var id = cardIdentity(card);
          if (id) seen[id] = true;
        });
        return seen;
      }

      function htmlFromCollection(markup, maxCards, seenSeed) {
        var doc = new DOMParser().parseFromString(markup, 'text/html');
        var seen = seenSeed || {};
        return Array.prototype.slice.call(doc.querySelectorAll('.product-card')).filter(function (card) {
          var id = cardIdentity(card);
          if (!id || seen[id]) return false;
          seen[id] = true;
          return true;
        }).slice(0, maxCards || limit).map(function (card) {
          card.querySelectorAll('script').forEach(function (script) { script.remove(); });
          return '<div class="x-featured__card">' + card.outerHTML + '</div>';
        }).join('');
      }

      function ensureCurrentShelf() {
        var currentCount = row.querySelectorAll('.x-featured__card').length;
        if (currentCount >= limit) {
          modes[0].html = row.innerHTML;
          return Promise.resolve();
        }

        return fetch('/collections/all?sort_by=manual', {
          credentials: 'same-origin',
          headers: { Accept: 'text/html', 'Cache-Control': 'no-cache' }
        })
          .then(function (response) { return response.ok ? response.text() : ''; })
          .then(function (markup) {
            if (!markup) return;
            var needed = Math.max(0, limit - row.querySelectorAll('.x-featured__card').length);
            if (!needed) return;
            var html = htmlFromCollection(markup, needed, seenCardsFrom(row));
            if (!html) return;
            row.insertAdjacentHTML('beforeend', html);
            modes[0].html = row.innerHTML;
          })
          .catch(function () {});
      }

      function loadMode(mode) {
        if (mode.loaded) return Promise.resolve(mode.html);
        return fetch(mode.url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
          .then(function (response) { return response.ok ? response.text() : ''; })
          .then(function (markup) {
            var html = markup ? htmlFromCollection(markup, limit) : '';
            mode.html = html || modes[0].html;
            mode.loaded = true;
            return mode.html;
          })
          .catch(function () { return modes[0].html; });
      }

      function maxScroll() {
        return Math.max(0, row.scrollWidth - row.clientWidth);
      }

      function featuredCardStep() {
        var card = row.querySelector('.x-featured__card');
        var styles = window.getComputedStyle ? window.getComputedStyle(row) : null;
        var gap = styles ? parseFloat(styles.columnGap || styles.gap || '0') : 0;
        return card ? card.getBoundingClientRect().width + (gap || 0) : Math.max(280, row.clientWidth * 0.55);
      }

      function syncEdgeAffordance() {
        edgeSyncFrame = null;
        if (!edgePrev || !edgeNext) return;

        var max = maxScroll();
        var canScroll = window.innerWidth >= 961 && max > 4;
        var left = row.scrollLeft;
        var canGoLeft = canScroll && left > 4;
        var canGoRight = canScroll && left < max - 4;
        var anchor = row.querySelector('.bottle-wrap') || row;
        var anchorRect = anchor.getBoundingClientRect();
        var sectionRect = section.getBoundingClientRect();

        if (anchorRect.height && sectionRect.height) {
          section.style.setProperty('--x-featured-row-center', (anchorRect.top - sectionRect.top + (anchorRect.height / 2)) + 'px');
        }

        edgePrev.hidden = !canGoLeft;
        edgeNext.hidden = !canGoRight;
        edgePrev.disabled = !canGoLeft;
        edgeNext.disabled = !canGoRight;
        section.classList.toggle('has-scroll-left', canGoLeft);
        section.classList.toggle('has-scroll-right', canGoRight);
      }

      function queueEdgeAffordanceSync() {
        if (edgeSyncFrame) return;
        edgeSyncFrame = window.requestAnimationFrame(syncEdgeAffordance);
      }

      function scrollFeaturedShelf(direction) {
        stopEdgeScroll();
        row.scrollBy({
          left: direction * Math.max(featuredCardStep() * 2, row.clientWidth * 0.7),
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
        window.setTimeout(queueEdgeAffordanceSync, 120);
        window.setTimeout(queueEdgeAffordanceSync, 520);
      }

      function canHoverScroll(event) {
        if (reduceMotion) return false;
        if (event && event.pointerType && event.pointerType !== 'mouse') return false;
        return window.innerWidth >= 961;
      }

      function stopEdgeScroll() {
        edgeVelocity = 0;
        edgeLastTime = 0;
        row.style.scrollSnapType = '';
        row.style.scrollBehavior = '';
        row.classList.remove('is-edge-scrolling', 'is-edge-scroll-left', 'is-edge-scroll-right');
        section.classList.remove('is-edge-scroll-left', 'is-edge-scroll-right');
        if (edgeFrame) {
          window.cancelAnimationFrame(edgeFrame);
          edgeFrame = null;
        }
        queueEdgeAffordanceSync();
      }

      function runEdgeScroll(now) {
        edgeFrame = null;
        if (!edgeVelocity || !canHoverScroll()) {
          stopEdgeScroll();
          return;
        }

        var max = maxScroll();
        if (max <= 4) {
          stopEdgeScroll();
          return;
        }

        var delta = edgeLastTime ? Math.min(2.2, Math.max(0.5, (now - edgeLastTime) / 16.67)) : 1;
        edgeLastTime = now || 0;
        var next = Math.max(0, Math.min(max, row.scrollLeft + (edgeVelocity * delta)));
        if (Math.abs(next - row.scrollLeft) > 0.1) row.scrollLeft = next;

        if ((next <= 0 && edgeVelocity < 0) || (next >= max && edgeVelocity > 0)) {
          edgeVelocity = 0;
          stopEdgeScroll();
          return;
        }

        queueEdgeAffordanceSync();
        if (edgeVelocity) edgeFrame = window.requestAnimationFrame(runEdgeScroll);
      }

      function updateEdgeScroll(event) {
        if (!canHoverScroll(event)) {
          stopEdgeScroll();
          return;
        }

        var rect = row.getBoundingClientRect();
        if (!rect.width || event.clientY < rect.top - 120 || event.clientY > rect.bottom + 90) {
          stopEdgeScroll();
          return;
        }

        var zone = Math.min(320, Math.max(150, rect.width * 0.24));
        var leftRatio = Math.min(1, Math.max(0, zone - (event.clientX - rect.left)) / zone);
        var rightRatio = Math.min(1, Math.max(0, zone - (rect.right - event.clientX)) / zone);
        var maxSpeed = Math.min(46, Math.max(30, row.clientWidth * 0.022));
        var velocity = 0;

        if (leftRatio > 0) velocity = -Math.pow(leftRatio, 1.12) * maxSpeed;
        if (rightRatio > 0) velocity = Math.pow(rightRatio, 1.12) * maxSpeed;

        edgeVelocity = velocity;
        if (velocity !== 0) {
          row.style.scrollSnapType = 'none';
          row.style.scrollBehavior = 'auto';
        }
        row.classList.toggle('is-edge-scrolling', velocity !== 0);
        row.classList.toggle('is-edge-scroll-left', velocity < 0);
        row.classList.toggle('is-edge-scroll-right', velocity > 0);
        section.classList.toggle('is-edge-scroll-left', velocity < 0);
        section.classList.toggle('is-edge-scroll-right', velocity > 0);

        if (edgeVelocity && !edgeFrame) edgeFrame = window.requestAnimationFrame(runEdgeScroll);
        if (!edgeVelocity) stopEdgeScroll();
      }

      function initEdgeArrows() {
        if (!edgePrev || !edgeNext || section.dataset.xFeaturedEdgeArrowsInit === '1') return;
        section.dataset.xFeaturedEdgeArrowsInit = '1';
        edgePrev.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          scrollFeaturedShelf(-1);
        });
        edgeNext.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          scrollFeaturedShelf(1);
        });
        row.addEventListener('scroll', queueEdgeAffordanceSync, { passive: true });
        window.addEventListener('resize', queueEdgeAffordanceSync, { passive: true });
        if (window.ResizeObserver) {
          new ResizeObserver(queueEdgeAffordanceSync).observe(row);
        }
        queueEdgeAffordanceSync();
      }

      function initHoverEdgeScroll() {
        if (section.dataset.xFeaturedHoverScrollInit === '1') return;
        section.dataset.xFeaturedHoverScrollInit = '1';
        if (!row.hasAttribute('tabindex')) row.setAttribute('tabindex', '0');
        section.addEventListener('pointermove', updateEdgeScroll, { passive: true });
        section.addEventListener('pointerleave', stopEdgeScroll, { passive: true });
        row.addEventListener('wheel', stopEdgeScroll, { passive: true });
        row.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          row.scrollBy({
            left: (event.key === 'ArrowRight' ? 1 : -1) * Math.max(280, row.clientWidth * 0.55),
            behavior: 'smooth'
          });
        });
        window.addEventListener('blur', stopEdgeScroll, { passive: true });
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) stopEdgeScroll();
        });
        if (edgeMedia && edgeMedia.addEventListener) {
          edgeMedia.addEventListener('change', stopEdgeScroll);
        } else if (edgeMedia && edgeMedia.addListener) {
          edgeMedia.addListener(stopEdgeScroll);
        }
      }

      function setMode(key) {
        var mode = modes.filter(function (item) { return item.key === key; })[0] || modes[0];
        var thisLoad = ++loadId;
        if (kicker) kicker.textContent = mode.kicker;
        if (titleMain) titleMain.textContent = mode.titleMain;
        if (titleItalic) titleItalic.textContent = mode.titleItalic;
        if (lede) lede.textContent = mode.lede;
        if (link) {
          link.textContent = mode.linkText;
          link.setAttribute('href', mode.linkHref);
        }
        if (modesEl) modesEl.setAttribute('data-active', mode.key);
        buttons.forEach(function (button) {
          var active = button.getAttribute('data-x-featured-mode') === mode.key;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        row.classList.add('is-refreshing');
        stopEdgeScroll();
        loadMode(mode).then(function (html) {
          if (thisLoad !== loadId) return;
          row.innerHTML = html;
          row.scrollTo({ left: 0, behavior: 'auto' });
          queueEdgeAffordanceSync();
          row.classList.remove('is-refreshing');
          normalizeProductCardPrices(row, limit);
          sync();
        });
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          setMode(button.getAttribute('data-x-featured-mode'));
        });
      });

      normalizeProductCardPrices(row, limit);
      ensureCurrentShelf().then(function () {
        normalizeProductCardPrices(row, limit);
        queueEdgeAffordanceSync();
        sync();
      });
      initHoverEdgeScroll();
      initEdgeArrows();
    });
  }

  function hydrateCachedHomeSections() {
    if (window.__xtraitHomeHydrated) return;
    var isHome = document.body && document.body.classList.contains('is-home');
    if (!isHome && window.location.pathname !== '/') return;
    var isStale = document.querySelector('.x-moods__tabs, [data-x-mood-mode]') || !document.querySelector('[data-x-featured-mode]');
    if (!isStale) {
      initFeaturedFallback(document);
      return;
    }

    var sectionIds = [];
    ['featured', 'moods'].forEach(function (suffix) {
      var node = document.querySelector('[id^="shopify-section-template--"][id$="__' + suffix + '"]');
      if (node && node.id) sectionIds.push(node.id.replace(/^shopify-section-/, ''));
    });
    if (!sectionIds.length) return;
    window.__xtraitHomeHydrated = true;

    fetch('/?sections=' + sectionIds.join(','), { credentials: 'same-origin', headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (sections) {
        if (!sections) return;
        sectionIds.forEach(function (id) {
          if (!sections[id]) return;
          var target = document.getElementById('shopify-section-' + id);
          if (!target) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = sections[id];
          var fresh = tmp.firstElementChild;
          if (fresh) target.replaceWith(fresh);
        });
        initFeaturedFallback(document);
        normalizeProductCardPrices(document, 80);
        sync();
      })
      .catch(function () {});
  }

  function openDrawer() {
    var drawer = document.querySelector('[data-x-wishlist-drawer]');
    var scrim = document.querySelector('.x-wishlist-scrim');
    if (!drawer) return;
    drawer.setAttribute('open', '');
    if (scrim) scrim.hidden = false;
    document.body.classList.add('is-wishlist-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var drawer = document.querySelector('[data-x-wishlist-drawer]');
    var scrim = document.querySelector('.x-wishlist-scrim');
    if (!drawer) return;
    drawer.removeAttribute('open');
    if (scrim) scrim.hidden = true;
    document.body.classList.remove('is-wishlist-open');
    document.body.style.overflow = '';
  }

  function fixLoumariHeroCache() {
    var hero = document.querySelector('[data-x-hero]');
    if (!hero) return;

    var productHandle = 'loumari-amber-malatya';
    var productName = 'Amber Malatya';
    var scentTag = 'Apricot \u00b7 Amber \u00b7 Cinnamon';
    var bottleSub = 'Apricot, amber, cinnamon.';
    var loumariVideo = hero.querySelector('.x-hero-video[data-handle="' + productHandle + '"]') ||
      hero.querySelector('.x-hero-video[data-handle="loumari-porthole"]');
    var originalHandle = loumariVideo ? (loumariVideo.getAttribute('data-handle') || '') : '';
    if (loumariVideo) {
      loumariVideo.setAttribute('data-house', 'Loumari');
      loumariVideo.setAttribute('data-cologne', productName);
      loumariVideo.setAttribute('data-tag', scentTag);
      loumariVideo.setAttribute('data-handle', productHandle);
      if (originalHandle && originalHandle !== productHandle) {
        loumariVideo.removeAttribute('data-variant-id');
      }
      loumariVideo.setAttribute('webkit-playsinline', '');
      loumariVideo.setAttribute('playsinline', '');
      loumariVideo.setAttribute('muted', '');
      loumariVideo.removeAttribute('controls');
      loumariVideo.muted = true;
      loumariVideo.defaultMuted = true;
      loumariVideo.playsInline = true;
      if (loumariVideo.classList.contains('is-active')) {
        try {
          var playAttempt = loumariVideo.play();
          if (playAttempt && typeof playAttempt.catch === 'function') playAttempt.catch(function () {});
        } catch (err) {}
      }
    }

    var house = hero.querySelector('[data-x-hero-house]');
    var cologne = hero.querySelector('[data-x-hero-cologne]');
    var tag = hero.querySelector('[data-x-hero-tag]');
    if (!house || house.textContent.trim() === 'Loumari') {
      if (cologne && cologne.textContent.trim() === 'Porthole') {
        cologne.textContent = productName;
      }
      if (tag && (/Pineapple|Sea Salt|Porthole/i.test(tag.textContent) || cologne && cologne.textContent.trim() === productName)) {
        tag.textContent = scentTag;
      }
    }

    var shopLink = hero.querySelector('[data-x-hero-shop]');
    var shopLabel = hero.querySelector('[data-x-hero-shop-label]');
    if (shopLink && /loumari-porthole|loumari-amber-malatya/i.test(shopLink.getAttribute('href') || '')) {
      var variantId = originalHandle === productHandle && loumariVideo ? (loumariVideo.getAttribute('data-variant-id') || '') : '';
      shopLink.setAttribute('href', '/products/' + productHandle + (variantId ? '?variant=' + variantId : ''));
    }
    if (shopLabel && /Porthole|Amber Malatya/i.test(shopLabel.textContent || '')) {
      shopLabel.textContent = 'Shop ' + productName;
    }

    var lockupSub = hero.querySelector('.x-hero-lockup-sub');
    if (lockupSub && /French house|Pineapple|sea salt|iodine/i.test(lockupSub.textContent)) {
      lockupSub.textContent = bottleSub;
    }

    var nowPouring = hero.querySelector('.x-hero-lockup-pouring');
    if (nowPouring && /Porthole/i.test(nowPouring.textContent)) {
      nowPouring.textContent = productName + ' \u00b7 Fresh arrival';
    }
  }

  function fixBrandsPageCache() {
    var grid = document.querySelector('[data-x-brands-grid]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-brand-name]'));
    if (!cards.length) return;

    var fallbackTaglines = {
      borntostandout: 'Korean niche with a DGAF attitude.',
      lepoque: 'American niche with romantic, fruit-bright polish.'
    };

    cards.forEach(function (card) {
      var handle = (card.getAttribute('data-brand-handle') || '').toLowerCase();
      var nameKey = (card.getAttribute('data-brand-name') || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
      var fallback = fallbackTaglines[handle] || fallbackTaglines[nameKey];
      if (!fallback) return;

      var meta = card.querySelector('.x-brands__card-meta');
      var tagline = card.querySelector('.x-brands__tagline');
      if (!tagline && meta) {
        tagline = document.createElement('div');
        tagline.className = 'x-brands__tagline';
        meta.appendChild(tagline);
      }
      if (tagline) tagline.textContent = fallback;
    });

    var collator = new Intl.Collator(undefined, {
      sensitivity: 'base',
      numeric: true,
      ignorePunctuation: true
    });
    cards
      .sort(function (a, b) {
        var aName = (a.getAttribute('data-brand-name') || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
        var bName = (b.getAttribute('data-brand-name') || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
        return collator.compare(aName, bName);
      })
      .forEach(function (card) { grid.appendChild(card); });

    var section = grid.closest('.x-brands');
    if (section) section.setAttribute('data-brands-sorted', 'true');
  }

  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-x-open-wishlist]');
    if (open) {
      event.preventDefault();
      sync();
      openDrawer();
      return;
    }

    if (event.target.closest('[data-x-close-wishlist]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var remove = event.target.closest('[data-x-wishlist-remove]');
    if (remove) {
      event.preventDefault();
      var removeId = remove.getAttribute('data-x-wishlist-remove');
      write(read().filter(function (item) { return String(item.id) !== String(removeId); }));
      sync();
      return;
    }

    var button = event.target.closest('[data-x-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    var item = normalizeButton(button);
    if (!item.id) return;

    var items = read();
    if (isSaved(items, item.id)) {
      items = items.filter(function (saved) { return String(saved.id) !== String(item.id); });
    } else {
      items.unshift(item);
    }
    write(items);
    sync();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  document.addEventListener('xtrait:wishlist:sync', sync);
  document.addEventListener('DOMContentLoaded', function () {
    installFeaturedEdgeFix();
    fixLoumariHeroCache();
    fixBrandsPageCache();
    sync();
    hydrateCachedHomeSections();
    initPriceObserver();
    initSearchPriceObserver();
    normalizeProductCardPrices(document, 80);
    normalizeSearchPrices(document);
  });
  document.addEventListener('shopify:section:load', function () {
    installFeaturedEdgeFix();
    fixLoumariHeroCache();
    fixBrandsPageCache();
    sync();
    initFeaturedFallback(document);
    initPriceObserver();
    initSearchPriceObserver();
    normalizeProductCardPrices(document, 80);
    normalizeSearchPrices(document);
  });

  installFeaturedEdgeFix();
  fixLoumariHeroCache();
  fixBrandsPageCache();
  setTimeout(fixLoumariHeroCache, 250);
  setTimeout(fixBrandsPageCache, 250);
  setTimeout(function () { initSearchPriceObserver(); normalizeSearchPrices(document); }, 250);
  window.addEventListener('pageshow', fixBrandsPageCache);
  window.addEventListener('pageshow', fixLoumariHeroCache);
  window.addEventListener('pageshow', function () { scheduleSearchPriceNormalize(document); });
})();
